import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, TextField } from '@cimpress/react-components';

import '../../css/sizeSelection.css';

const sizeSelection = ({ onSelectWidth, onSelectHeight, width, height, colorMap }) => (
    <div className='size-control'>
        <Accordion title='Size Options' defaultOpen={true}>
            <div className='color-attribute size-control__width' style={{ borderColor: colorMap.width }}>
                <TextField label='width' value={width} onChange={e => onSelectWidth(e.target.value)} type='number' />
            </div>
            <div className='color-attribute size-control__height' style={{ borderColor: colorMap.height }}>
                <TextField label='height' value={height} onChange={e => onSelectHeight(e.target.value)} type='number' />
            </div>
        </Accordion>
    </div>
);

sizeSelection.propTypes = {
    onSelectHeight: PropTypes.func.isRequired,
    onSelectWidth: PropTypes.func.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    colorMap: PropTypes.shape({
        width: PropTypes.string.isRequired,
        height: PropTypes.string.isRequired,
    }).isRequired,
};

export default sizeSelection;



// WEBPACK FOOTER //
// ./src/components/rendering/sizeSelection.jsx